import { useState } from "react";
import axios from "../../axios/AxiosInstance";

const cancellationReasons = [
  "Concurrence",
  "Plus de besoin",
  "Trop cher",
  "Ne répond plus",
  "Pas de candidat à proposer",
  "Atradius refusé",
];

function CancelOrderModal({ orderId, closeModal, onCancelOrder }) {
  const [selectedReason, setSelectedReason] = useState("");

  const handleConfirmCancel = async () => {
  if (!selectedReason) return alert("Veuillez choisir un motif.");

  try {
    const response = await axios.post(`/order/${orderId}/cancel`, { reason: selectedReason });

    // Le back doit renvoyer la commande mise à jour avec status: "annulée"
    const updatedOrder = response.data;

    // On appelle la fonction parent avec l'objet complet
    onCancelOrder(response.data);
    // Ferme le modal
    closeModal();
  } catch (error) {
    console.error("Erreur lors de l'annulation :", error);
  }
};



  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
  <div className="bg-white rounded-xl p-6 w-full max-w-md">
    <h2 className="text-xl font-semibold mb-4">Annuler la commande</h2>
    <p className="mb-4">Choisissez le motif de l'annulation :</p>

    <div className="flex flex-col gap-2 mb-6">
      {cancellationReasons.map((reason) => (
        <label key={reason} className="flex items-center gap-2">
          <input
            type="radio"
            name="cancelReason"
            value={reason}
            checked={selectedReason === reason}
            onChange={() => setSelectedReason(reason)}
            className="accent-red-500"
          />
          {reason}
        </label>
      ))}
    </div>

    <div className="flex justify-end gap-3">
      <button
        onClick={closeModal}
        className="px-4 py-2 rounded-md bg-gray-300 hover:bg-gray-400 transition"
      >
        Fermer
      </button>
      <button
        onClick={handleConfirmCancel}
        disabled={!selectedReason}
        className={`px-4 py-2 rounded-md text-white transition ${
          selectedReason ? "bg-red-600 hover:bg-red-700" : "bg-red-300 cursor-not-allowed"
        }`}
      >
        Confirmer l'annulation
      </button>
    </div>
  </div>
</div>

  );
}

export default CancelOrderModal;
